'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const MillisecondsPerHour=timespan.fromHours(1).totalMilliseconds();let

TwentyFourHourAxisLabelDirective=class TwentyFourHourAxisLabelDirective extends BaseControllerBackedDirective{
get objectBindings(){return['timeFormatter']}

get controller(){return TwentyFourHourAxisLabelController}};let


TwentyFourHourAxisLabelController=class TwentyFourHourAxisLabelController extends BaseResizableDirectiveController{
static get $inject(){return['$scope','$element','$window']}

constructor($scope,$element,$window){
super($scope,$element,$window);

this._svgElement=null;

this.oneDayInterval=new TimeInterval('2014-01-01T00:00:00.000Z','2014-01-02T00:00:00.000Z');

$scope.$watch('controller.dimensions.width',()=>this._updateScale());
$scope.$watch('controller.scale',()=>this._render());
}

_updateScale(){
if(_.exists(this.dimensions)&&_.exists(this.dimensions.width)){
this._scale=d3.time.scale.utc().domain([this.oneDayInterval.start,this.oneDayInterval.end]).range([0,this.dimensions.width]);
}else{
this._scale=null;
}
}

get scale(){
return this._scale;
}

_render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.scale)){
return;
}

this._refreshSvg();

let xAxisGroup=d3.select(this._svgElement).append('g').attr({
class:'x-axis',
transform:`translate(0, ${this.dimensions.height})`}).
call(this._drawTimeAxis());

xAxisGroup.
selectAll('line').
data(this.scale.ticks(this.oneDayInterval.duration.totalMilliseconds()/MillisecondsPerHour),_.identity).
enter().
append('line').
attr({
class:'minor',
y1:0,
y2:-3,
x1:this.scale,
x2:this.scale});


xAxisGroup.
selectAll('text').
style({
"text-anchor":'start'});

}

_drawTimeAxis(){
return d3.svg.axis().
scale(this.scale).
orient('top').
ticks(d3.time.hours.utc,2).
innerTickSize(7).
outerTickSize(1).
tickFormat(this.timeFormatter);
}

_refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
}};


module.exports=TwentyFourHourAxisLabelDirective;
//# sourceMappingURL=twentyFourHourAxisLabelDirective.js.map
